import React from 'react';

const Title = () => {
      let css1 = {
        marginTop: "70px",
        textAlign: "center",
      };
    return (
      <div>
        <h3 style={css1}>MD's Pick</h3>
        <p style={{textAlign: "center"}}>시선을 사로잡는 스타일링, 제품들을 만나보세요.</p>
      </div>
    );
};

export default Title;